import axios from "axios";

import { Vessel } from "../models/vessel";

export const postVessel = async (vessel: Vessel) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_API}/Vessel/vessel`,
      vessel
    );
    return response;
  } catch (error: any) {
    console.error(error);
    return error.response;
  }
};
